@if (performanceRankingSlotList) {

    <div cdkDropList [cdkDropListData]="performanceRankingSlotList" (cdkDropListDropped)="onDrop($event)" 
        class="w-full md:w-3/4 lg:w-1/2 space-y-4">

        @for (performanceRankingSlot of performanceRankingSlotList; track performanceRankingSlot.sequenceNo) {

            <div cdkDrag 
                [cdkDragDisabled]="!performanceRankingSlot.performanceRanking" 
                [cdkDragStartDelay]="{ touch: 300, mouse: 300 }"
                (cdkDragStarted)="onDrag(performanceRankingSlot.sequenceNo)"
                (cdkDragEnded)="onDragStop()"
                class="h-18 w-full items-center select-none touch-manipulation cursor-grab">

                @if(performanceRankingSlot.performanceRanking; as performanceRanking) {

                    <div class="h-full w-full flex border rounded-lg border border-slate-500"
                        [class.bg-gray-200]="!dragReady && performanceRanking.ranked"
                        [class.bg-white]="!dragReady && !performanceRanking.ranked"
                        [class.bg-red]="dragReady">
                        <div class="flex shrink-0 w-[48px] justify-center items-center">
                            <p class="text-2xl font-semibold">{{ performanceRankingSlot.sequenceNo + 1 }}</p>
                        </div>
                        <div class="grow min-w-0 pt-3 pb-3">
                            <h3 class="mb-1">{{ performanceRanking.performanceName }}</h3>
                            <p class="text-lg truncate">{{ performanceRanking.name }} -
                                @for (performerName of performanceRanking.performerNameList; track performerName) {
                                    {{ performerName }}
                                }
                            </p>
                        </div>
                        @if(_userService.isLoggedIn$ | async) {
                            <div class="flex shrink-0 w-[48px] items-center">
                                @if (!performanceRanking.rating || performanceRanking.rating.rating === PerformanceRatingsEnum.NotSet) {
                                    <app-outline-star-icon (click)="openRatingModal(performanceRanking)"
                                        class="block w-[44px] h-[44px] cursor-pointer text-gray-300 hover:text-gray-500 transition">
                                    </app-outline-star-icon>
                                }
                                @else {
                                    <app-solid-star-icon (click)="openRatingModal(performanceRanking)"
                                        class="block w-[44px] h-[44px] cursor-pointer transition"
                                        [ngClass]="{
                                            'text-[#64B02B]': performanceRanking.rating.rating === PerformanceRatingsEnum.Love,
                                            'text-[#EBC310]': performanceRanking.rating.rating === PerformanceRatingsEnum.Like,
                                            'text-[#C21F1B]': performanceRanking.rating.rating === PerformanceRatingsEnum.Loathe,
                                            'hover:text-[#71C731]': performanceRanking.rating.rating === PerformanceRatingsEnum.Love,
                                            'hover:text-[#FCD111]': performanceRanking.rating.rating === PerformanceRatingsEnum.Like,
                                            'hover:text-[#E62520]': performanceRanking.rating.rating === PerformanceRatingsEnum.Loathe
                                        }">
                                    </app-solid-star-icon>
                                }
                            </div>
                        }
                    </div>

                }
                @else {
                    <div class="h-full w-full flex border rounded-lg p-4 border-slate-200">
                        <div class="flex h-full w-18 justify-center items-center">
                            <p class="text-slate-200 text-3xl font-semibold">{{ performanceRankingSlot.sequenceNo }}</p>
                        </div>
                    </div>
                }
            </div>
        }
    </div> 

    @if (openPerformanceRanking) {

        <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
            <div class="w-full max-w-md rounded-xl bg-white p-6 shadow-lg">
                <h3>Rating</h3>
                <div class="flex items-center">
                    <app-rate-with-trim
                        [(rating)]="currentPerformanceRating">
                    </app-rate-with-trim>
                </div>

                <div class="flex justify-end gap-2">
                    <button
                        type="button"
                        class="rounded-lg border border-slate-300 px-4 py-2 hover:bg-slate-100"
                        (click)="closeRatingModal()">
                        Cancel
                    </button>

                    <button
                        type="button"
                        class="rounded-lg bg-slate-800 px-4 py-2 text-white hover:bg-slate-700"
                        (click)="saveRatingValue()">
                        Save
                    </button>
                </div>
            </div>
        </div>

    }

}